




































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PaymentMethods',
})
export default class PaymentMethods extends Vue {
  protected paymentMethod = 'creditCard';

  protected get activeCheckoutMethod() {
    return this.$store.getters['user/activeCheckoutMethod'];
  }

  protected onPaymentMethodChange() {
    this.$emit('change', this.paymentMethod);
  }
}
